import { render, staticRenderFns } from "./printDocProspeccao.vue?vue&type=template&id=4defaf6e&scoped=true"
import script from "./printDocProspeccao.vue?vue&type=script&lang=js"
export * from "./printDocProspeccao.vue?vue&type=script&lang=js"
import style0 from "./printDocProspeccao.vue?vue&type=style&index=0&id=4defaf6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4defaf6e",
  null
  
)

export default component.exports